import Vue from 'vue'
// import axios from 'axios'
import App from './App.vue'
// import Buefy from 'buefy'
// import '@/assets/buefy-sliced.css'
// import firebase from 'firebase/app'
import i18n from '@/i18n'

// Importing the global css file
import '@/assets/global.css'

Vue.config.productionTip = false
// Vue.prototype.$http = axios
// Vue.use(Buefy)

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
